'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

var _utils = require('../utils');

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageCarousel = function () {
  function ImageCarousel(el) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, ImageCarousel);

    this.el = el;
    this.context = { context: el };

    this.els = {
      el: el,
      itemsContainer: (0, _functional.getElement)('.prd-Results_CarouselItems', this.context),
      items: (0, _functional.getElements)('.prd-Results_CarouselItem', this.context),
      controls: (0, _functional.getElement)('prd-Results_Controls', this.context),
      prevControl: (0, _functional.getElement)('.prd-Results_Control-prev', this.context),
      nextControl: (0, _functional.getElement)('.prd-Results_Control-next', this.context)
    };

    this.slidesCount = this.els.items.length;

    this.initCarousel();
    window.addEventListener('resize', function () {
      return _this2.handleResize();
    });
  }

  (0, _createClass3.default)(ImageCarousel, [{
    key: 'initCarousel',
    value: function initCarousel() {
      if (window.innerWidth >= 768) {
        this.destroyCarousel();
        return;
      }

      if (this.carousel) return;

      var _this = this;
      this.carousel = new _siema2.default({
        selector: this.els.itemsContainer,
        duration: 500,
        perPage: 1.25,
        onInit: function onInit() {
          _this.initialiseControls(this);
          _this.els.el.setAttribute('data-initialised', true);
        },
        onChange: function onChange() {
          _this.updateControlsDisabledStatus(this);
        }
      });
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      if (window.innerWidth >= 768) {
        this.destroyCarousel();
      } else {
        this.initCarousel();
      }
    }
  }, {
    key: 'destroyCarousel',
    value: function destroyCarousel() {
      if (!this.carousel) return;

      this.carousel.destroy(true);
      this.carousel = null;
      this.els.el.removeAttribute('data-initialised');
    }
  }, {
    key: 'updateControlsDisabledStatus',
    value: function updateControlsDisabledStatus(carousel) {
      if (carousel.currentSlide === 0) {
        this.els.prevControl.setAttribute('disabled', true);
        this.els.nextControl.removeAttribute('disabled');
      } else if (carousel.currentSlide === 0.75) {
        this.els.prevControl.removeAttribute('disabled');
        this.els.nextControl.setAttribute('disabled', true);
      } else {
        this.els.prevControl.removeAttribute('disabled');
        this.els.nextControl.removeAttribute('disabled');
      }
    }
  }, {
    key: 'initialiseControls',
    value: function initialiseControls(carousel) {
      var _this3 = this;

      // On load
      this.updateControlsDisabledStatus(carousel);

      // Events
      this.els.prevControl.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return carousel.prev();

              case 2:
                _this3.updateControlsDisabledStatus(carousel);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      })));
      this.els.nextControl.addEventListener('click', (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return carousel.next();

              case 2:
                _this3.updateControlsDisabledStatus(carousel);

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      })));
    }
  }]);
  return ImageCarousel;
}();

exports.default = ImageCarousel;